import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const { login, error, setError, checking } = useAuth();
  const navigate     = useNavigate();
  const location     = useLocation();
  const from         = location.state?.from?.pathname || "/admin-dashboard";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (honeypot) { setError("Invalid email or password."); return; }
    const success = await login(email, password);
    if (success) {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden px-6">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 30% 20%, rgba(185,28,28,0.12) 0%, transparent 55%), " +
            "radial-gradient(ellipse at 80% 80%, rgba(185,28,28,0.08) 0%, transparent 50%)",
        }}
      />

      <div className="relative w-full max-w-md">
        <p className="text-xs uppercase tracking-[0.35em] text-red-600 font-semibold mb-4 text-center">
          Staff Access
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white uppercase leading-none tracking-tight text-center mb-2">
          Admin <span className="text-red-600">Login</span>
        </h1>
        <div className="mx-auto mt-6 mb-10 w-12 h-0.5 bg-red-700" />

        <form
          onSubmit={handleSubmit}
          className="bg-white/[0.03] border border-white/10 backdrop-blur-sm p-8 sm:p-10"
          noValidate
        >
          {/* Honeypot - invisible to real users, catches bots */}
          <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", overflow: "hidden" }}>
            <label htmlFor="company">Company</label>
            <input type="text" id="company" name="company" tabIndex="-1" autoComplete="off"
              value={honeypot} onChange={(e) => setHoneypot(e.target.value)} />
          </div>

          <div className="mb-6">
            <label htmlFor="email" className="block text-xs uppercase tracking-widest text-white/50 font-semibold mb-2">
              Email
            </label>
            <input type="email" id="email" name="email" autoComplete="username"
              value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-black/40 border border-white/15 text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors duration-200"
            />
          </div>

          <div className="mb-8">
            <label htmlFor="password" className="block text-xs uppercase tracking-widest text-white/50 font-semibold mb-2">
              Password
            </label>
            <input type="password" id="password" name="password" autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-black/40 border border-white/15 text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors duration-200"
            />
          </div>

          {error && <p className="mb-6 text-sm text-red-500" role="alert">{error}</p>}

          <button type="submit" disabled={checking}
            className="w-full px-8 py-3 bg-red-700 hover:bg-red-600 disabled:opacity-40 text-white font-bold uppercase tracking-widest text-xs transition-colors duration-200">
            {checking ? "Checking…" : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
